import type { SVGProps } from "react";

export function IconDarkPurplePeople3(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 23.375H4.125V28.875H16.5M16.5 23.375V28.875M16.5 23.375H28.875V28.875H16.5M13.75 15.8125C13.75 17.711 12.211 19.25 10.3125 19.25C8.41402 19.25 6.875 17.711 6.875 15.8125C6.875 13.914 8.41402 12.375 10.3125 12.375C12.211 12.375 13.75 13.914 13.75 15.8125ZM26.125 15.8125C26.125 17.711 24.586 19.25 22.6875 19.25C20.789 19.25 19.25 17.711 19.25 15.8125C19.25 13.914 20.789 12.375 22.6875 12.375C24.586 12.375 26.125 13.914 26.125 15.8125ZM19.9375 6.875C19.9375 8.77348 18.3985 10.3125 16.5 10.3125C14.6015 10.3125 13.0625 8.77348 13.0625 6.875C13.0625 4.97652 14.6015 3.4375 16.5 3.4375C18.3985 3.4375 19.9375 4.97652 19.9375 6.875Z"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
    </svg>
  );
}
